import { render } from "./CompanyProfile.vue?vue&type=template&id=5ceb432a&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"

import "./CompanyProfile.vue?vue&type=style&index=0&id=5ceb432a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ceb432a"]])

export default __exports__